import {
  LISTING_SET_SORT_CRITERIA,
  LISTING_SET_ACL_QUERY_MODE,
  LISTING_RESET_PAGE_NUMBERS,
  LISTING_SET_TOTAL_ITEMS,
  LISTING_SET_TOTAL_PAGES,
  LISTING_SET_CURRENT_PAGE,
  LISTING_SET_LAYOUT,
  LISTING_DESELECT_CARD,
  LISTING_SELECT_CARD,
} from 'js/constants/actionTypes';
import { ACLQueryModeTypes } from 'js/constants/visibilityFilters';
import Constants from 'js/Constants';

export const selectCard = (id) => {
  return {
    type: LISTING_SELECT_CARD,
    payload: {
      id,
    },
  };
};

export const deselectCard = () => {
  return {
    type: LISTING_DESELECT_CARD,
  };
};

export const setLayout = (layout) => {
  return {
    type: LISTING_SET_LAYOUT,
    payload: {
      layout,
    },
  };
};

export const setCurrentPage = (currentPage) => {
  return {
    type: LISTING_SET_CURRENT_PAGE,
    payload: {
      currentPage,
    },
  };
};

export const setTotalPages = (totalPages) => {
  return {
    type: LISTING_SET_TOTAL_PAGES,
    payload: {
      totalPages,
    },
  };
};

export const setTotalItems = (totalItems) => {
  return {
    type: LISTING_SET_TOTAL_ITEMS,
    payload: {
      totalItems,
    },
  };
};

export const resetPageNumbers = () => {
  return {
    type: LISTING_RESET_PAGE_NUMBERS,
  };
};

export const setSortCriteria = (sortCriteria) => {
  return {
    type: LISTING_SET_SORT_CRITERIA,
    payload: {
      sortCriteria,
    },
  };
};

export const setListingACLQueryMode = (aclQueryMode = ACLQueryModeTypes.MODE_OWNER.key) => {
  return {
    type: LISTING_SET_ACL_QUERY_MODE,
    payload: {
      aclQueryMode,
    },
  };
};

export const resetSortCriteria = () => {
  return {
    type: LISTING_SET_SORT_CRITERIA,
    payload: {
      sortCriteria: Constants.SortCriteria.LAST_CREATED_DESC,
    },
  };
};
